<template>
  <el-dialog
  :title="`${type === 'new' ? '新增' : '编辑'}`"
  :visible.sync="show"
  :before-close="close"
  center
  >
    <el-form ref="addForm" :rules="rules" :model="addInfo" label-width="20%">
      <el-form-item label="证件类型" prop="paperType">
        <el-select v-model="addInfo.paperType" placeholder="请选择" clearable filterable style="width: 100%;">
          <el-option v-for="item in fileTypeList" :key="item.id" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件名" prop="name">
        <el-input v-model="addInfo.name"/>
      </el-form-item>
      <el-form-item label="文件类型">
        <el-radio v-model="addInfo.attchmentType" label="IMG" :disabled="type !== 'new'">图片</el-radio>
        <el-radio v-model="addInfo.attchmentType" label="PDF" :disabled="type !== 'new'">PDF文档</el-radio>
      </el-form-item>
      <el-form-item label="附件" v-if="addInfo.attchmentType === 'PDF'">
        <uploadPreviewFile v-model="addInfo.file" type="new" accept=".pdf"/>
      </el-form-item>
      <el-form-item label="附件"  v-if="addInfo.attchmentType === 'IMG'">
        <el-upload
        action=""
        accept="image/jpeg,image/jpg,image/png,.pdf"
        list-type="picture-card"
        :http-request="httpRequest"
        :file-list="fileListPic"
        :on-remove="handleRemove"
        :before-upload="beforeAvatarUpload"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <!-- <div class="el-upload__tip" slot="tip">只能上传图片 / PDF 任意一种类型</div> -->
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addEventForm()">提 交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { uploadFile } from '@/api/user'
import { add, update } from '@/api/compPaper'
import uploadPreviewFile from '@/components/upload/uploadPreviewFile'
export default {
  data () {
    return {
      show: false,
      fileTypeList: [
        {
          value: '营业执照（复印件）',
          label: '营业执照（复印件）'
        },
        {
          value: '产证（复印件）',
          label: '产证（复印件）'
        },
        {
          value: '法人身份证（复印件）',
          label: '法人身份证（复印件）'
        },
        {
          value: '营业执照（原件）',
          label: '营业执照（原件）'
        },
        {
          value: '产证（原件）',
          label: '产证（原件）'
        },
        {
          value: '法人身份证（原件）',
          label: '法人身份证（原件）'
        },
        {
          value: '个人证件',
          label: '个人证件'
        },
        {
          value: '其他',
          label: '其他'
        },
      ],
      fileListPic: [],
      addInfo: {
        name: '',
        paperType: '',
        file: '',
        id: '',
        attchmentType: 'IMG'
      },
      rules: {
        name: [{ required: true, message: '请输入证件名称', trigger: 'blur' }],
        paperType: [{ required: true, message: '请选择证件类型', trigger: 'blur' }],
        file: [{ required: true, message: '请上传证件附件', trigger: 'change' }]
      },
      type: ''
    }
  },
  components: {
    uploadPreviewFile
  },
  computed: {
    getImage () {
      return `${location.origin}${process.env.VUE_APP_BASE_API}/minio/getImage?fileName=${this.addInfo.file}`
    }
  },
  methods: {
    showDialog (type = 'new', data) {
      this.type = type
      if (type !== 'new') {
        this.fileListPic = []
        this.addInfo = {
          name: data.paperName,
          paperType: data.paperType,
          attchmentType: data.attchmentType,
          file: data.attchmentUrl,
          id: data.id
        }
        // console.log(data.attchmentUrl, 'aaaaaaaaaa');
        data.attchmentUrl && data.attchmentUrl.split(',').forEach(item => {
          this.fileListPic.push({
            fileName: item,
            url: process.env.VUE_APP_BASE_API + `/minio/getImage?fileName=${item}`,
            code: `invoiceUrl${item}`
          })
        });
      }
      this.show = true
    },
    close () {
      this.show = false
      this.addInfo = {
        name: '',
        paperType: '',
        file: '',
        id: '',
        attchmentType: 'IMG'
      }
      this.fileListPic = []
    },
    beforeAvatarUpload (file) {
       // 格式过滤
      let fileType = ['png', 'jpg', 'jpeg'] 
      let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType.indexOf(testmsg) >= 0
      if (!extension) {
        this.$message.error('仅支持png, jpg, jpeg格式')
      }
      return extension
    },
    async httpRequest (param) {
      console.log(param.file.type, 'param');
      let file = param.file
      let fd = new FormData()
      fd.append('file', file)
      const { code, result, message } = await uploadFile(fd)
      if (code === 0) {
        this.fileListPic.push({
          fileName: result,
          url: process.env.VUE_APP_BASE_API + '/minio/getImage?fileName=' + result,
          code: result,
          type: param.file.type.split('/')[1]
        })
        this.addInfo.file = result // 后端接收的参数类型是string，所以要转换成string
      } else {
        this.$message.error(message)
      }
    },
    // 图片删除
    handleRemove (val) {
      console.log(val);
      this.fileListPic = this.fileListPic.filter(v => v.fileName !== val.fileName)
      this.addInfo.file = this.fileListPic.join(',')
    },
    addEventForm () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let json = {
            'new': add,
            'edit': update
          }
          if (!json[this.type]) return
          json[this.type]({
            attchmentUrl: this.addInfo.attchmentType === 'IMG' ? (this.fileListPic.map(v => v.fileName)).join(',') : this.addInfo.file,
            attchmentType: this.addInfo.attchmentType,
            paperName: this.addInfo.name,
            paperType: this.addInfo.paperType,
            id: this.addInfo.id
          }).then(res => {
            const { code } = res
            if (code !== 0) return
            this.$message.success(`${this.type === 'new' ? '新增' : '编辑'}证件成功`)
            this.$emit('addSuccess')
            this.close()
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog{
  min-width: 900px;
  width: 30%;
}
.avatar-uploader-none {
  /deep/ .el-upload--picture-card {
    display: none;
  }
}
// .avatar-uploader {
//   /deep/ .el-upload {
//     border: 1px dashed #d9d9d9;
//     border-radius: 6px;
//     cursor: pointer;
//     position: relative;
//     overflow: hidden;
//   }
//   /deep/ .el-upload:hover {
//     border-color: #409EFF;
//   }
//   .avatar-uploader-icon {
//     font-size: 28px;
//     color: #8c939d;
//     width: 178px;
//     height: 178px;
//     line-height: 178px;
//     text-align: center;
//   }
//   .avatar {
//     width: 178px;
//     height: 178px;
//     display: block;
//   }
// }
</style>
